/**
 * Shared by the window-level chunk recovery handler and the route error UI.
 * The window handler intentionally accepts only Error instances, while React
 * Router can provide a plain object, so each caller extracts the message at its
 * own input boundary before using this predicate.
 *
 * Chrome: "failed to fetch dynamically imported module".
 * Firefox: "error loading dynamically imported module".
 * Safari/WebKit: "importing a module script failed" and "failed to load module script".
 * Webpack: "loading chunk" and "loading css chunk". The generic dynamic-import
 * fragment also covers variations of the Chrome and Firefox messages.
 */
export const CHUNK_LOAD_ERROR_PATTERNS = [
  'failed to fetch dynamically imported module',
  'loading chunk',
  'loading css chunk',
  'dynamically imported module',
  'importing a module script failed',
  'failed to load module script',
  'error loading dynamically imported module',
]

export function isChunkLoadErrorMessage(message: string): boolean {
  const normalizedMessage = message.toLowerCase()
  return CHUNK_LOAD_ERROR_PATTERNS.some(pattern => normalizedMessage.includes(pattern))
}
